//@ts-expect-error no type definition for baselines
import { rollingBallBaseline as baselineFct } from 'baselines';
/**
 * @param data
 */
export function rollingBallBaseline(data) {
    data.y = baselineFct(data.y).correctedSpectrum;
    return { data };
}
//# sourceMappingURL=rollingBallBaseline.js.map